import { useTheme } from "@mui/material/styles";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import { Box, Typography } from "@mui/material";
import { HEADER_HEIGHT } from "../../Pages/Home/PageRestau";

const TEAL = "#2D9B8F";
const ICON_INACTIVE = "#6B7280";

export default function SideBarBrand({ leftDrawerOpened, onClose }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        px: 1.5,
        py: 1.5,
        gap: 1.5,
        height: HEADER_HEIGHT,
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          bgcolor: TEAL,
          borderRadius: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <StorefrontIcon sx={{ color: "white", fontSize: 20 }} />
      </Box>
      {leftDrawerOpened && (
        <>
          <Typography
            sx={{ fontWeight: 700, fontSize: 16, color: "#111827", flexGrow: 1 }}
          >
            Backoffice
          </Typography>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{ color: ICON_INACTIVE, ":hover": { bgcolor: "#F3F4F6" } }}
          >
            {theme.direction === "rtl" ? (
              <ChevronRightIcon fontSize="small" />
            ) : (
              <ChevronLeftIcon fontSize="small" />
            )}
          </IconButton>
        </>
      )}
    </Box>
  );
}
